<template>
    <el-dialog
            title="选择费用类别"
            :visible.sync="dialogFormVisible"
            custom-class="medium-dialog"
            center
            :close-on-click-modal="true"
            :append-to-body="true"
            :modal="true"
    >

        <el-form ref="form1">
            <!--<el-collapse v-model="activeNames_ChangYong">-->
                <!--<el-collapse-item name='0'>-->
                    <!--<template slot="title">-->
                        <!--<span>常用</span>-->
                    <!--</template>-->
                    <!--<el-row>-->
                        <!--<el-col :span="24">-->
                            <!--<ul style="padding-bottom: 20px;padding-left: 15px;">-->
                                <!--<li @click="chooseCategory(changyong_item)" class="category-third"-->
                                    <!--v-for="(changyong_item,index) in  changyong_fee"-->
                                    <!--:key="changyong_item.categorycode" v-if="index<8">-->
                                    <!--<span>{{changyong_item.text}}</span>-->
                                <!--</li>-->
                            <!--</ul>-->
                        <!--</el-col>-->
                    <!--</el-row>-->
                <!--</el-collapse-item>-->
            <!--</el-collapse>-->
            <el-collapse accordion v-show="categoryTreeData.length" v-for="(category_first,index) in categoryTreeData"
                         v-model="activeNames"
                         :key="category_first.categorycode">

                <el-collapse-item :name="index">
                    <template slot="title">
                        <span>{{category_first.text}}</span>
                    </template>
                    <el-row class="row-category-second" v-for="category_second in category_first.children"
                            :key="category_second.categorycode" v-if="category_second.children.length > 0">
                        <el-col :span="4">
                            <span class="category-second-display">{{category_second.text}}</span>
                        </el-col>
                        <el-col :span="20">
                            <ul>
                                <li @click="chooseCategory(category_third)" class="category-third"
                                    v-for="category_third in  category_second.children"
                                    :key="category_third.categorycode">
                                    <span>{{category_third.text}}</span>
                                </li>
                            </ul>
                        </el-col>
                    </el-row>
                </el-collapse-item>
            </el-collapse>
        </el-form>
    </el-dialog>

</template>

<style scoped>

    .row-category-second {
      margin: 0 0 10px 0;
      padding-bottom: 15px;
    }

    .category-second {
        text-align: center;
        cursor: pointer;
    }
.category-second-display{
  text-align: center;
  color: #9B9B9B;
}
    .category-third {
      cursor: pointer;
      display: inline-block;
      margin: 5px 20px 5px 20px;
      min-width: 80px;
      font-size: 13pt;
    }

    .category-second:hover, .category-third:hover {
        color: #15a4fa;
    }
</style>
<script>
    import {getCategoryTree,getListNoPage} from "@/api/set/Category";

    export default {
        props: ["filltemplate", "parentcategorycode"],
        data() {
            return {
                activeNames_ChangYong: '0',
                activeNames: [0],
                dialogFormVisible: false,
                categorylist: [],
                categoryTreeData: [],
                selCategoryCode: "",//选择的费用编码
                selCategoryName: "",
                needfapiao: true,//需要发票
                MustFaPiao:false,//增值税专票
                tickettotaxpercent:"",//抵扣进项税率
                changyong_fee: [],//页面显示的根据大类筛选后常用费用，从浏览器缓存中取
                all_changyong:[],//全部常用费用
            };
        },
        methods: {
          initCangYong() {
            //localStorage.setItem("changyong_fee", JSON.stringify([]));
            this.all_changyong = localStorage.getItem("changyong_fee");
            if (!this.all_changyong) {
              this.all_changyong = [];
            }
            else {
              this.all_changyong = JSON.parse(this.all_changyong);
            }
            //大类下的类别
            this.changyong_fee = this.all_changyong.filter(element => {
              return element.categorycode.startsWith(this.parentcategorycode);
            });
            //根据权重排序
            this.changyong_fee.sort(function (a, b) {
              return a.weight < b.weight;
            })
            //设置分类名称，匹配不到的名称设置为空
            var FirstCat = this.categoryTreeData[0].children;
            for (var i = 0; i < this.changyong_fee.length; i++) {
              this.changyong_fee[i].text = '';
              for (var j = 0; j < FirstCat.length; j++) {
                if (FirstCat[j].id == this.changyong_fee[i].categorycode) {
                  this.changyong_fee[i].text = FirstCat[j].text;
                  this.changyong_fee[i].id = FirstCat[j].id;
                  this.changyong_fee[i].attributes= FirstCat[j].attributes;
                } else {
                  //判断第三级
                  for (var n = 0; n < FirstCat[j].children.length; n++) {
                    if (FirstCat[j].children[n].id == this.changyong_fee[i].categorycode) {
                      this.changyong_fee[i].text = FirstCat[j].children[n].text;
                      this.changyong_fee[i].id = FirstCat[j].children[n].id;
                      this.changyong_fee[i].attributes= FirstCat[j].children[n].attributes;
                      break;
                    }
                  }
                }
                if (this.changyong_fee[i].text != '') {
                  break;
                }
              }
              if (this.changyong_fee[i].text == '') {
                this.changyong_fee.splice(i--, 1);
              }
            }
          },
          setCangYong(changyongItem) {
            //选择过的都添加到常用费用中，去除重复与增加权重
            var exist = false;
            //选择的费用增加权重
            for (var i = 0; i < this.all_changyong.length; i++) {
              if (this.all_changyong[i].categorycode == changyongItem.id) {
                this.all_changyong[i].weight = this.all_changyong[i].weight + 1;
                exist = true;
                break;
              }
            }
            if (!exist) {
              //不存在，添加到常用中
              this.all_changyong.push({
                categorycode: changyongItem.id,
                weight: 1
              });
            }
            localStorage.setItem("changyong_fee", JSON.stringify(this.all_changyong));
          },
          addPage() {
            this.dialogFormVisible = true;
            this.selCategoryCode = "";
            this.getCategoryList();
          },
          //获取一级费用列表，科目长度为3
          getCategoryList() {
            if (this.parentcategorycode) {
              getCategoryTree({
                onlyShowEnabledGroupType: true,
                categorytype: 100,
                filltemplate: this.filltemplate,
                parentcategorycode: this.parentcategorycode
              }).then(
                response => {
                  this.categoryTreeData = response.data.obj;
                  for (let i in this.categoryTreeData) {
                    var first = this.categoryTreeData[i];
                    var child = [];
                    for (let i in first.children) {
                      if (first.children[i].children && first.children[i].children.length == 0) {
                        child.push(first.children[i]);
                      }
                    }
                    if (child.length > 0) {
                      first.children.push({text: first.text, categorycode: first.categorycode, children: child});
                    }
                  }
                  // this.initCangYong();
                }
              );
            }
          },
          //选择费用
          chooseCategory(selItem) {
            //只有最后一级费用才能被选择
            this.selCategoryCode = selItem.id;
            this.selCategoryName = selItem.text;
            if (selItem.attributes) {
              this.needfapiao = selItem.attributes.NeedFaPiao;
              this.tickettotaxpercent = selItem.attributes.tickettotaxpercent;
              this.MustFaPiao= selItem.attributes.MustFaPiao;
            }
            this.setCangYong(selItem);
            this.$emit("afterSelFeeType");
            this.dialogFormVisible = false;
          }
        }
    };
</script>



// WEBPACK FOOTER //
// src/components/oa/payform/SelectFeeType.vue